export default __webpack_public_path__ + "static/media/buffering.34da336e.jpg";